import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Field, Form, reduxForm } from "redux-form";
import FormElement from "../../forms/form_element";
import Autocomplete from "../../forms/autocomplete/autocomplete";
import { seedcastForm } from "../../../lib/forms";
import "./import_form.scss";
import { gtagEvent, ACTIONS, CATEGORIES } from "../../../lib/google_analytics";
import LoadingImage from "../../lib/image";

const standardSearchClass = "feed-import-form__show-search";
const standardRSSClass = "feed-import-form__feed-url";

class ImportForm extends Component {
  state = {
    searchMode: true,
    isLoading: false,
  };

  doSubmit = values => {
    gtagEvent(ACTIONS.SUBMIT, CATEGORIES.IMPORT_FORM);
    this.props.feedImport(values.feedURL, 128).then(responseData => {
      if (responseData && responseData.status === 200) {
        this.props.onSubmit(values);
        this.props.history.push("/shows/" + responseData.showUUID);
        this.props.fetchJobsForUser(this.props.user);
      }
    });
  };

  getToggledFieldClasses = () => {
    return {
      search: standardSearchClass + (!this.state.searchMode ? " hidden" : ""),
      rss: standardRSSClass + (this.state.searchMode ? " hidden" : ""),
    };
  };

  toggleFeedInput = e => {
    e.preventDefault();
    this.setState({ searchMode: false }, () =>
      gtagEvent(ACTIONS.CLICK, CATEGORIES.FEED_INPUT_TOGGLE)
    );
  };

  render() {
    const toggledFieldClasses = this.getToggledFieldClasses();

    return (
      <Form onSubmit={this.props.handleSubmit(this.doSubmit)}>
        <div className={toggledFieldClasses.search}>
          <Field
            component={FormElement}
            InputComponent={Autocomplete}
            name="showName"
            label="Podcast Name"
            type="text"
            limit={10}
            placeholder="Enter Podcast Name"
            validationErrors={this.props.validationErrors}
            suggestions={this.props.searchResults || []}
            fetchSuggestions={value => {
              return this.props.searchDirectoryShows(value, this.props.user);
            }}
            isLoading={this.state.isLoading}
            clearSuggestions={() => {}}
            getItemValue={item => {
              return item.trackName;
            }}
            renderItem={item => {
              return (
                <span key={item.uuid}>
                  <LoadingImage
                    src={item.imageURL}
                    alt="album-art"
                    className={"directory-show-image"}
                  />
                  {item.trackName}
                </span>
              );
            }}
            onSelect={suggestion => {
              this.props.setFeedURL(suggestion.feedURL);
            }}
          />
          <Button
            className="btn-link import-form__rss-feed-switch"
            data-cy="switch-manual-url"
            onClick={this.toggleFeedInput}>
            Or, enter your RSS feed URL manually
          </Button>
        </div>
        <div className={toggledFieldClasses.rss}>
          <Field
            component={FormElement}
            name="feedURL"
            label="RSS Feed"
            type="text"
            placeholder="RSS Feed URL"
            validationErrors={this.props.validationErrors}
          />
          <Button
            className="btn-link import-form__rss-feed-switch"
            onClick={e => {
              e.preventDefault();
              this.setState({ searchMode: true });
            }}>
            Search by podcast title
          </Button>
        </div>
      </Form>
    );
  }
}

export default seedcastForm(
  reduxForm({
    form: "feed-import",
  })(ImportForm),
  {
    submissionFilter: values => values,
  }
);
